import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./GoodSans-Regular.woff%22,%22weight%22:%22400%22,%22style%22:%22regular%22},{%22path%22:%22./GoodSans-Regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22regular%22},{%22path%22:%22./GoodSans-Medium.woff%22,%22weight%22:%22500%22,%22style%22:%22medium%22},{%22path%22:%22./GoodSans-Medium.woff2%22,%22weight%22:%22500%22,%22style%22:%22medium%22}],%22variable%22:%22--font-goodsans%22}],%22variableName%22:%22goodSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'goodSans', 'goodSans Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
